/**
 * Created by lenovo on 2019/3/23 0023.
 */
const player = null;
export default {
  player
}




// WEBPACK FOOTER //
// ./src/global.js